

export const SET_LOADING = "SET_LOADING";

export const setLoading = (requestName, requestState) => ({
    type: SET_LOADING,
    payload: {
        data: {
            requestName,
            requestState
        }
    }
});
